import {
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles
} from "@material-ui/core";
import React from "react";
import OptimizedTooltip from "../common/OptimizedTooltip";
import clsx from "clsx";
import { remCalc } from "../../utils/helpers";

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: theme.spacing(0.5, 2),
    margin: theme.spacing(1, 0),
    "&:last-child": {
      marginBottom: theme.spacing(0.5)
    },
    "&:first-child": {
      marginTop: theme.spacing(0.5)
    },
    minHeight: theme.spacing(5),
    transition: theme.transitions.create(["padding-left, padding-right"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    "& svg": {
      fontSize: "24px"
    },
    "&:hover": {
      backgroundColor: "#EEE"
    }
  },
  listItemText: {
    fontWeight: 500,
    color: "#4D4D50",
    fontSize: remCalc(14)
  },
  listItemOpen: {
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1)
  },
  listItemActive: {
    backgroundColor: "#ECEEFF",
    "&:hover": {
      backgroundColor: "#D9DDFF"
    },
    "& *": {
      color: "#1329FE"
    }
  }
}));

const CustomListItem = ({
  IconComponent,
  text,
  clickHandler = () => {},
  open,
  disabled,
  notBusiness,
  active
}) => {
  const classes = useStyles();

  return (
    <OptimizedTooltip
      title={
        notBusiness ? "Available only on our Business plan" : open ? "" : text
      }
      placement={notBusiness && open ? "bottom" : "left"}
    >
      <span
        style={
          disabled
            ? { cursor: "not-allowed", display: "flex" }
            : { display: "flex" }
        }
      >
        <ListItem
          button
          disabled={disabled}
          className={clsx(classes.listItem, {
            [classes.listItemOpen]: open,
            [classes.listItemActive]: active
          })}
          data-cy={`rightMenu-${text.toLowerCase()}`}
          onClick={() => {
            clickHandler();
          }}
        >
          <ListItemIcon>
            <IconComponent color={active ? "primary" : "default"} />
          </ListItemIcon>
          <ListItemText
            primary={text}
            classes={{ primary: classes.listItemText }}
          />
        </ListItem>
      </span>
    </OptimizedTooltip>
  );
};

export default CustomListItem;
